import $ from "jquery";
import Bacon from "Bacon";
import c from "common";
import support from "support";

var $body = $("body");
var clickStream = new Bacon.Bus();

function toggleDropdownOptions($dropdown) {
  var $options = $dropdown.find(".custom-dropdown-options");
  var toggleTo = !$options.is(":visible");

  if (clickStream.subscriptions.length === 0) {
    clickStream = new Bacon.Bus();
    clickStream.onValue(c.subscribe);
  }

  $dropdown.toggleClass("open", toggleTo);
  if (toggleTo) {
    clickStream.plug($body.asEventStream("click").map($dropdown));
  } else {
    clickStream.end();
  }
}

function hideDropdownOptions($dropdown) {
  $dropdown.removeClass("open");
}

function selectOption(event) {
  var $selected = c.$target(event);
  var $dropdown = getCurrentDropdown(event);
  var selectedValue = $selected.attr("data-value");

  $dropdown.find(".dropdown-item").removeClass("selected");
  $selected.addClass("selected");

  $dropdown.find(".customDropdownSelect").text($selected.text()).attr("data-value", selectedValue);
  $dropdown.find("option[value='" + selectedValue + "']").prop("selected", true);
  toggleDropdownOptions($dropdown);
}

function weekdayWildcardOption(event) {
  var $selected = c.$target(event).closest(".dropdown-item");
  var $dropdown = getCurrentDropdown(event);
  var $icon = getCurrentIcon($selected).first();
  var $selectedDropdownItem = $selected.closest(".dropdown-item");
  var selectedValue = $selectedDropdownItem.attr("data-value");
  var selectedText = $selected.text().substring(0, 2).toLowerCase();

  var isSelected = $selectedDropdownItem.hasClass("multiSelected");
  var currentText = $dropdown.find(".customDropdownSelect").text();
  var currentValue = $dropdown.find(".customDropdownSelect").attr("data-value");

  if (isSelected || !selectedValue) {
    $selectedDropdownItem.removeClass("multiSelected");
    $icon.addClass("ea-icon--check-hidden");
    var newValue = removeStringFromArray(currentValue.split(","), selectedValue).join();
    var newText = removeStringFromArray(currentText.split(","), selectedText).join();
    $dropdown.find(".customDropdownSelect").text(newText);
    $dropdown.find(".customDropdownSelect").attr("data-value", newValue);

    $dropdown.find("option[value='" + selectedValue + "']").prop("selected", false);
  } else {
    $selectedDropdownItem.addClass("multiSelected");
    $icon.removeClass("ea-icon--check-hidden");
    if (currentText.length > 0) {
      // sort selected days based on data-days-order
      var daysOrderArray = $("#weekdays-order").attr("data-days-order").split(",");
      var sortedSelectedDays = [];
      for (var i = 0; i < daysOrderArray.length; i++) {
        if (currentText.includes(daysOrderArray[i]) || daysOrderArray[i] === selectedText) {
          sortedSelectedDays.push(daysOrderArray[i]);
        }
      }
      $dropdown.find(".customDropdownSelect").text(sortedSelectedDays.join(","));
    } else {
      $dropdown.find(".customDropdownSelect").text(selectedText);
    }

    if (currentValue.length > 0) {
      $dropdown.find(".customDropdownSelect").attr("data-value", currentValue + "," + selectedValue);
    } else {
      $dropdown.find(".customDropdownSelect").attr("data-value", selectedValue);
    }
    $dropdown.find("option[value='" + selectedValue + "']").prop("selected", true);
  }
}

function removeStringFromArray(array, value) {
  for (var i=array.length-1; i>=0; i--) {
    if (array[i] === value) {
      array.splice(i, 1);
      break;
    }
  }
  return array;
}

function selectOptionWithValue(value, $dropdown) {
  var $selectedItem = $dropdown.find("[data-value='" + value + "']");
  if ($selectedItem.length === 0) {
    $selectedItem = $dropdown.find("option:first-child");
  }

  $dropdown.find(".dropdown-item").removeClass("selected");
  $selectedItem.addClass("selected");
  $dropdown.find(".customDropdownSelect").text("").text($selectedItem.text()).attr("data-value", value);
  $dropdown.find("option[value='" + value + "']").prop("selected", true);
}

function weekdayWildcardsOptionWithCommaSeparatedValues(selectedValues, allValues, $dropdown) {
  var allSelectedValues = selectedValues.split(",");
  var allValuesSplitted = allValues.split(",");

  $dropdown.find(".customDropdownSelect").text("");

  // first hide all the icons
  allValuesSplitted.forEach(function (splittedValue) {
    var $selectedItem = $dropdown.find("[data-value='" + splittedValue + "']");

    var $icon = getCurrentIcon($selectedItem).first();
    $icon.addClass("ea-icon--check-hidden");
  });

  // mark all selected values and show icons
  var customDropdownSelectDataValues = "";
  var customDropdownSelectText = "";
  allSelectedValues.forEach(function (splittedValue) {
    var $selectedItem = $dropdown.find("[data-value='" + splittedValue + "']");

    if ($selectedItem.length === 0) {
      $selectedItem = $dropdown.find("option:first-child");
    }

    $selectedItem.addClass("multiSelected");
    var $icon = getCurrentIcon($selectedItem).first();
    $icon.removeClass("ea-icon--check-hidden");

    var selectedTextSubstring = $selectedItem.text().substring(0, 2).toLowerCase();

    // test
    if (customDropdownSelectText.length > 0) {
      customDropdownSelectText += "," + selectedTextSubstring;
      customDropdownSelectDataValues += "," + splittedValue;
    } else {
      customDropdownSelectText = selectedTextSubstring;
      customDropdownSelectDataValues = splittedValue;
    }

    $dropdown.find("option[value='" + splittedValue + "']").prop("selected", true);
  });

  $dropdown.find(".customDropdownSelect").text(customDropdownSelectText).attr("data-value", customDropdownSelectDataValues);
}

function getCurrentDropdown(event) {
  return c.$target(event).closest(".custom-dropdown");
}

function getCurrentIcon(event) {
  return event.children();
}

function getCurrentSiblingDropdown(event) {
  return c.$target(event).siblings(".custom-dropdown");
}

function initDropdowns() {
  $.each($(".custom-dropdown"), function () {
    if ($(this).attr("class").includes("weekday-wildcards-dropdown")) {
      initWeekdayWildcardsDropdown($(this));
      weekdayWildcardsOptionWithCommaSeparatedValues("mon,tue,wed,thu,fri,sat,sun", "mon,tue,wed,thu,fri,sat,sun", $(this));
    } else {
      initSingleDropdown($(this));
    }
  });
}

function initSingleDropdown($dropdown) {
  if (!support.isMobile()) {
    var initValue = $dropdown.find(".dropdown-item:first").addClass("selected").attr("data-value");

    $dropdown.find("select").hide();
    $dropdown.find(".customDropdownSelect").css("display", "block").attr("data-value", initValue);

    $dropdown.asEventStream("click", ".custom-dropdown-select-wrapper").doAction(c.stopEvent).map(getCurrentDropdown).filter(isNotDisabled).onValue(toggleDropdownOptions);
    $dropdown.asEventStream("click", ".dropdown-item").doAction(c.stopEvent).onValue(selectOption);
  }
}

function initWeekdayWildcardsDropdown($dropdown) {
  if (!support.isMobile()) {
    $dropdown.find("select").hide();
    $dropdown.find(".dropdown-item:first").removeClass("selected");
    $dropdown.find(".customDropdownSelect").css("display", "block");
    $dropdown.find(".dropdown-item").removeClass("multiSelected");

    $dropdown.asEventStream("click", ".custom-dropdown-select-wrapper").doAction(c.stopEvent).map(getCurrentDropdown).filter(isNotDisabled).onValue(toggleDropdownOptions);
    $dropdown.asEventStream("click", ".dropdown-item").doAction(c.stopEvent).onValue(weekdayWildcardOption);
  }
}

function isNotDisabled($dropdown) {
  return !$dropdown.hasClass("disabled");
}

clickStream.onValue(toggleDropdownOptions);

export default {
  init: initDropdowns,
  initSingle: initSingleDropdown,
  initWeekdayWildcardsDropdown,
  get: getCurrentDropdown,
  getSibling: getCurrentSiblingDropdown,
  toggleOptions: toggleDropdownOptions,
  hideOptions: hideDropdownOptions,
  select: selectOptionWithValue,
  weekdayWildcardsOptionWithCommaSeparatedValues,
};



// WEBPACK FOOTER //
// ./web/js/dropdown.js